import React from 'react'
import { useLottie } from "lottie-react";

const LottieView = ({ animationData, loop = true, autoplay = true, className = "" }) => {
  const options = {
    animationData: animationData,
    className: className,
    autoplay: autoplay,
    loop: loop,
  }
  const { View } = useLottie(options)

  return <>{View}</>
}

export default LottieView;
